import React from 'react';
import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Calendar,
  Clipboard,
  X,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  MoreHorizontal,
  Eye,
  EyeOff,
  AlertTriangle,
  ExternalLink,
  Layers,
  Info,
  Maximize,
  Link,
  List,
  Lock,
  Search,
  Pencil,
  Power,
  User,
  ArrowLeftToLine,
  ArrowRightToLine,
  Settings,
  ArrowUpDown,
  Unlock,
  Play,
  Pause,
  Upload,
  PanelRightClose,
  PanelRightOpen,
  MousePointer2,
  Camera,
  LayoutGrid,
  Move,
  Sun,
  Type,
  Maximize2,
  Circle,
  Expand,
  RefreshCcw,
  Film,
  Crosshair,
  Target,
  Compass,
  Square,
  Palette,
  Scaling,
  Scissors,
  Trash2,
  SquareSlash,
  SquareCheck,
  CircleDashed,
  ArrowUp
} from 'lucide-react';

/** 
 * CUSTOM BRAND ICONS 
 * These must exist in your assets/icons folder as seen in your screenshot
 */
import deepechoLogo from './../../assets/icons/deepecho-logo.svg';
import deepechoLogo2 from './../../assets/icons/deepecho-logo_v2.svg';

const ICONS = {
  // Common UI
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-left-small': ArrowLeft,
  'arrow-right-small': ArrowRight,
  'calendar': Calendar,
  'clipboard': Clipboard,
  'close': X,
  'cancel': X,
  'dotted-circle': CircleDashed,
  'circled-checkmark': CheckCircle2,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-menu': MoreHorizontal,
  'chevron-next': ChevronRight,
  'chevron-prev': ChevronLeft,
  'chevron-right': ChevronRight,
  'eye-visible': Eye,
  'eye-hidden': EyeOff,
  'external-link': ExternalLink,
  'group-layers': Layers,
  'info': Info,
  'info-action': Info,
  'info-link': Info,
  'launch-arrow': ExternalLink,
  'launch-info': Info,
  'link': Link,
  'list-bullets': List,
  'lock': Lock,
  'magnifier': Search,
  'exclamation': AlertTriangle,
  'pencil': Pencil,
  'power-off': Power,
  'profile': User,
  'push-left': ArrowLeftToLine,
  'push-right': ArrowRightToLine,
  'settings': Settings,
  'sorting': ArrowUpDown,
  'sorting-active-down': ArrowDown,
  'sorting-active-up': ArrowUp,
  'status-alert': AlertTriangle,
  'status-locked': Lock,
  'status-tracked': CheckCircle2,
  'status-untracked': Circle,
  'tracked': CheckCircle2,
  'unlink': Link,

  // Tool Icons (Mapped to best Lucide equivalents)
  'tool-zoom': Search,
  'tool-capture': Camera,
  'tool-layout': LayoutGrid,
  'tool-more-menu': MoreHorizontal,
  'tool-move': Move,
  'tool-window-level': Sun,
  'tool-annotate': Type,
  'tool-bidirectional': Maximize2,
  'tool-elipse': Circle,
  'tool-circle': Circle,
  'tool-length': Expand,
  'tool-stack-scroll': Layers,
  'tool-magnify': Search,
  'tool-flip-horizontal': Scaling,
  'tool-invert': Sun,
  'tool-rotate-right': RefreshCcw,
  'tool-cine': Film,
  'tool-crosshair': Crosshair,
  'tool-probe': Target,
  'tool-angle': Compass,
  'tool-reset': RefreshCcw,
  'tool-rectangle': Square,
  'tool-fusion-color': Palette,
  'tool-calibration': Scaling,
  'tool-freehand': Scissors,
  'tool-polygon': Scissors,

  // UI Components
  'icon-search': Search,
  'icon-play': Play,
  'icon-pause': Pause,
  'icon-next': ChevronRight,
  'icon-prev': ChevronLeft,
  'icon-upload': Upload,
  'navigation-panel-right-hide': PanelRightClose,
  'navigation-panel-right-reveal': PanelRightOpen,
  'ui-arrow-down': ChevronDown,
  'ui-arrow-up': ChevronUp,
  'checkbox-checked': SquareCheck,
  'checkbox-unchecked': Square,
  'notifications-info': Info,
  'notifications-error': AlertTriangle,
  'notifications-success': CheckCircle2,
  'notifications-warning': AlertTriangle,

  // Old OHIF / Misc
  'old-trash': Trash2,
  'old-play': Play,
  'old-stop': SquareSlash,

  /** DEEPECHO BRANDING (Uses local SVGs) */
  'deepechoLogo': deepechoLogo,
  'deepechoLogo2': deepechoLogo2,
};

/**
 * Return the matching Lucide Icon or Brand SVG as a React Component.
 */
export default function getIcon(key, props) {
  if (!key || !ICONS[key]) {
    console.warn(`Icon "${key}" not found in ICONS registry.`);
    return React.createElement('div', null, '');
  }

  return React.createElement(ICONS[key], props);
}

export { getIcon, ICONS };